export class ApplicationClaimTypes {
    static administrator: string = "Administrator";
    static administrateLocation: string = "AdministrateLocation";
	static viewLocation: string = "ViewLocation";
	static viewZone: string = "ViewZone";
	static zoneNotification: string = "ZoneNotification";
}

